//@ts-check

/**
 * @type {import("./types").dashToCamelCaseType}
 */
// for optimization purpuses have the regex in constant variable
export var dashToCamelCase = function dashToCamelCase(name) {
  function upper(all, letter) {
    return letter.toUpperCase();
  }

  return name.replace(/-(\w)/g, upper);
};
export default dashToCamelCase;